import React from "react";
import { Link } from "gatsby";

const AdminNav = ({ path, label, icon, isActive, onClick ,icon1}) => {
    return (
        <div className="navbar-item">
            <img
                src={icon}
                alt={label}
                className={`navbar-icon ${isActive ? "active" : ""}`}
            />
            <Link
                to={path}
                className={`navbar-link ${isActive ? "active" : ""}`}
                onClick={onClick}
            >
                {label}
            </Link>
            <img
                src={icon1}
                alt={label}
                className={`downarrow-icon ${isActive ? "active" : ""}`}
            />
        </div>
    );
};

export default AdminNav;
